import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { parseQueryPageNumber } from "src/utils/helpers/requestApi/parseQueryPageNumber";
import { isStringQuery } from "src/utils/helpers/url/isStringQuery";
import {
  getSecondCategories,
  SecondCategoriesSchema,
} from "src/models/secondCategories/getSecondCategories";

export const useSecondCategories = (
  secondCategoryData: SecondCategoriesSchema
) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  const [data, setData] = useState<SecondCategoriesSchema>(secondCategoryData);

  const {
    query: { city, secondCatalog, page },
  } = useRouter();

  const cachedCatalog = useRef(secondCatalog);
  const currentPage = parseQueryPageNumber(page);

  const changePageHref = (pageNumber: number) => ({
    pathname:
      pageNumber === 1
        ? "/[city]/catalog/[secondCatalog]"
        : "/[city]/catalog/[secondCatalog]/[page]",
    query: {
      city,
      secondCatalog,
      ...(pageNumber !== 1 ? { page: `page-${pageNumber}` } : {}),
    },
  });

  useEffect(() => {
    if (
      isStringQuery(city) &&
      isStringQuery(secondCatalog) &&
      (data?.paginator?.page !== currentPage ||
        cachedCatalog.current !== secondCatalog)
    ) {
      setLoading(true);
      cachedCatalog.current = secondCatalog;
      getSecondCategories({
        page: currentPage,
        category_slug: secondCatalog,
        city_slug: city,
      })
        .then((res) => setData(res.data))
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));
    }
  }, [secondCatalog, city, page]);

  return { data, currentPage, changePageHref, isLoading };
};
